// Set some global "styling", to make the canvas full-screen, and disable HTML-based selection
const style: CSSStyleDeclaration = document.body.style;

// // Read the initial load-time theme
// // The editor does this, but we want to do it before the editor is loaded.
// const themeMatcher = window.matchMedia("(prefers-color-scheme: dark)");
// if (themeMatcher.matches) {
//   style.backgroundColor = "black";
// } else {
//   style.backgroundColor = "white";
// }

// Disable HTML-based selection.
style.userSelect = "none";
style.cursor = "default";

// Keep the ugly border that HTML puts by default from screwing up our nice full screen canvas
style.margin = "0";
style.padding = "0";

// Fonts: eh.
// style.fontFamily = '-apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Helvetica, Arial, sans-serif';

// FIXME: these have never really looked right.
// // Register the VSCode design system, and the components we use.
// import {
//   provideVSCodeDesignSystem,
//   vsCodeButton,
//   vsCodeTextArea,
// } from "@vscode/webview-ui-toolkit";

// provideVSCodeDesignSystem().register(
//   vsCodeButton(), //
//   vsCodeTextArea() //
// );
